<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
	<path d="M9,5L5,9v7h9V5H9z M13,15H6v-5h4V6h3V15z" />
	<polygon points="5,1 2,4 2,13 4,13 4,12 3,12 3,5 6,5 6,2 11,2 11,4 12,4 12,1" />
</svg>
</template>